<div class="container-fluid">
    <div class="row navigation">
        <div class="col-lg-12 d-flex justify-content-between">
            <a routerLink="/"><img src="/assets/img/logo.png" alt="Mercit logo"></a>
            <nav class="align-self-center d-none d-sm-block">
                <ul>
                    <li><a routerLink="/contact">Contact us</a></li>
                </ul>
            </nav>
            <div class="d-block d-sm-none btn-mobile-nav">
                <a (click)="setNavVisibility(true)">
                    <img src="/assets/img/btn-menu.svg"
                         alt="Menu navigation">
                </a>
            </div>
        </div>
        <nav class="mobile-nav d-block d-sm-none">
            <img src="/assets/img/close.svg" alt="Close button"
                 (click)="setNavVisibility(false)">
            <ul>
                <li><a routerLink="/contact">Contact us</a></li>
            </ul>
        </nav>
    </div>
    <router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/app.component.html